export default (state) => state.authentication.emailAddress
